import { DashboardLayout } from "../../components/dashboard-layout";
import { ThemeProvider } from "@mui/material/styles";
import { theme } from "../../theme";
import axios from "axios";
import { Alert, Box, Container, Pagination, Table, TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import { useEffect, useState } from "react";
import { isFeatureEnabled } from "../../utils/serverFeatures";

axios.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem("user");
        if (token) config.headers["Authorization"] = `Bearer ${token}`;
        return config;
    },
    (error) => Promise.reject(error)
);

function OnlineUsers() {
    const [users, setUsers] = useState([]);
    const [loading, setLoading] = useState(false);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [message, setMessage] = useState("");
    const onlineUsersSupported = isFeatureEnabled("onlineUsers");

    const fetchOnlineUsers = () => {
        if (!onlineUsersSupported) {
            setMessage("Server hiện tại chưa hỗ trợ endpoint /auth/online-users.");
            setUsers([]);
            setTotalPages(1);
            return;
        }

        setLoading(true);
        setMessage("");
        axios
            .get(`${process.env.REACT_APP_API_URL}/auth/online-users`, {
                params: { page, limit: 20 }
            })
            .then((res) => {
                setUsers(res.data.data || []);
                setTotalPages(res.data.totalPages || 1);
                setLoading(false);
            })
            .catch((error) => {
                setLoading(false);
                setMessage(error?.response?.data?.message || "Không lấy được danh sách user online.");
            });
    };

    useEffect(() => {
        fetchOnlineUsers();
    }, [page]);

    useEffect(() => {
        if (!onlineUsersSupported) return;
        const timer = setInterval(() => {
            fetchOnlineUsers();
        }, 15000);
        return () => clearInterval(timer);
    }, [page, onlineUsersSupported]);

    const handleChangePage = (e, newPage) => {
        setPage(newPage);
    };

    const formatDate = (value) => {
        const d = new Date(value);
        return `${d.getFullYear()}/${("0" + (d.getMonth() + 1)).slice(-2)}/${("0" + d.getDate()).slice(-2)} ${("0" + d.getHours()).slice(-2)}:${("0" + d.getMinutes()).slice(-2)}:${("0" + d.getSeconds()).slice(-2)}`;
    };

    return (
        <ThemeProvider theme={theme}>
            <DashboardLayout>
                <Box component="main" sx={{ flexGrow: 1, py: 1 }}>
                    {loading && (
                        <div className="loading" style={{ maxWidth: "100%", zIndex: 9999 }}>
                            <div className="loader"></div>
                        </div>
                    )}
                    <Container maxWidth={false}>
                        <div className="container_set">Danh sách user online</div>

                        {message ? (
                            <Alert severity={onlineUsersSupported ? "error" : "warning"} sx={{ mb: 2 }}>
                                {message}
                            </Alert>
                        ) : null}

                        <div className="form_set">
                            <Table className="table-admin">
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Tên tài khoản</TableCell>
                                        <TableCell>Số tiền</TableCell>
                                        <TableCell>Đã nạp</TableCell>
                                        <TableCell>Hoạt động gần đây</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {users.length > 0 ? (
                                        users.map((item) => (
                                            <TableRow key={item._id}>
                                                <TableCell>{item.username}</TableCell>
                                                <TableCell>{Number(item.money || 0).toLocaleString("vi-VN")}</TableCell>
                                                <TableCell>{Number(item.tongnap || 0).toLocaleString("vi-VN")}</TableCell>
                                                <TableCell>{formatDate(item.lastActiveAt)}</TableCell>
                                            </TableRow>
                                        ))
                                    ) : (
                                        <TableRow>
                                            <TableCell colSpan={4} align="center">
                                                Không có user online
                                            </TableCell>
                                        </TableRow>
                                    )}
                                </TableBody>
                            </Table>
                        </div>
                        <Box sx={{ display: "flex", justifyContent: "center", pt: 3 }}>
                            <Pagination color="primary" count={totalPages} page={page} onChange={handleChangePage} disabled={!onlineUsersSupported} />
                        </Box>
                    </Container>
                </Box>
            </DashboardLayout>
        </ThemeProvider>
    );
}

export default OnlineUsers;
